// Vendor libraries
import { ChangeDetectorRef, ElementRef, } from '@angular/core';
// Utils / constants
import { GUIDED_WORKFLOWS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
// Services
import { CookieService } from 'ngx-cookie-service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { GuidedWorkflowsService } from 'GuidedWorkflowsApp/ts/services/guided-workflows.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Components
import { GuidedWorkflowsMenuComponent } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/components/guided-workflows-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "GuidedWorkflowsApp/ts/services/guided-workflows.service";
import * as i5 from "@angular/common";
import * as i6 from "QuickflowsApp/ts/features/quickflows-menu/components/quickflows-menu.component";
import * as i7 from "../../../../../../apps/guided_workflows/static/guided_workflows/ts/features/guided-workflows-menu/components/guided-workflows-menu.component";
import * as i8 from "../../directives/icon/icon.directive";
const _c0 = a0 => ({ open: a0 });
function SideMenuComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 11);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleOpenClose("quickflows")); });
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5, "Quickflows");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isMenuOpened);
} }
function SideMenuComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 15);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleOpenClose("workflows")); });
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5, "Workflows");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isMenuOpened);
} }
function SideMenuComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_8_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clearSteps()); });
    i0.ɵɵtext(1, "Back to Workflow Categories");
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-quickflows-menu", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("displaySecurityId", ctx_r1.displaySecurityId)("securityId", ctx_r1.securityId)("securityName", ctx_r1.securityName)("securityUrl", ctx_r1.securityUrl);
} }
function SideMenuComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-guided-workflows-menu", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("pagePath", ctx_r1.pagePath)("categories", ctx_r1.categories)("selectedSubcategoryId", ctx_r1.selectedSubcategoryId);
} }
function SideMenuComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "a", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 19);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 20);
    i0.ɵɵtext(4, "Settings");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r1.userPreferencesUrl, i0.ɵɵsanitizeUrl);
} }
/**
 *
 * Side Menu Component
 *
 * Hosts app side tabs QuickflowsMenuComponent and GuidedWorkflowsMenuComponent.
 * Quickflows component inputs:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *   securityName: The security name to initialize this component with, e.g. Vanguard Financials Index Admiral
 *   securityUrl: The security url to navigate e.g.  /mutual_funds/M:VFAIX
 *
 * Workflows component inputs:
 *  pagePath: the page path url to get categories
 *
 */
export class SideMenuComponent {
    onScrollEvent() {
        this.sidePanelTop = window.scrollY < this.headerHeight ? this.headerHeight - window.scrollY : 0;
        this.sidePanelHeight =
            window.scrollY < this.headerHeight ? `calc(100vh - ${this.headerHeight - window.scrollY}px)` : '100vh';
    }
    constructor(changeDetector, eltRef, urlsService, featureService, cookieService, guidedWorkflowsService) {
        this.changeDetector = changeDetector;
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.cookieService = cookieService;
        this.guidedWorkflowsService = guidedWorkflowsService;
        this.showQuickflows = true;
        this.isMenuOpened = false;
        this.type = 'quickflows';
        this.userPreferencesUrl = '';
        this.showWorkflows = false;
        this.categories = [];
        this.headerHeight = 48;
        this.selectedSubcategoryId = null;
        this.displaySecurityId = this.eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
        this.showQuickflows = JSON.parse(this.eltRef.nativeElement.getAttribute('showQuickflows')) ?? true;
        this.pagePath = this.eltRef.nativeElement.getAttribute('pagePath');
    }
    ngOnInit() {
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.PROFILE_COMMUNICATIONS;
        const hasGuidedWorkflowsFeature = this.featureService.userHasFeatures([GUIDED_WORKFLOWS_FEATURE]);
        const subcategoryCookie = this.cookieService.get(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME) || '""';
        const subcategorySelectedId = JSON.parse(decodeURIComponent(subcategoryCookie));
        const unhashedLocation = window.location.toString().replace('/#/', '/');
        const newURL = new URL(unhashedLocation);
        const queryParams = new URLSearchParams(newURL.search);
        const guidedWorkFlow = queryParams.get('gw');
        const querySubcategoryId = guidedWorkFlow == null || Number.isNaN(guidedWorkFlow) ? null : Number(guidedWorkFlow);
        if (this.pagePath === undefined || this.pagePath === null) {
            this.pagePath = this.getPathName(window.location.pathname);
        }
        this.showWorkflows = hasGuidedWorkflowsFeature;
        if (this.pagePath) {
            this.guidedWorkflowsService.getPageGuidedWorkflows(this.pagePath).subscribe((categories) => {
                this.categories = categories;
                const allSubcategories = categories.reduce((accumulator, category) => accumulator.concat(category.subcategories), []);
                const selectedCategoryId = querySubcategoryId !== null ? querySubcategoryId : subcategorySelectedId;
                this.selectedSubcategoryId =
                    allSubcategories.find((subcategory) => subcategory.id === selectedCategoryId)?.id ?? null;
                if (this.selectedSubcategoryId !== null && !this.isMenuOpened) {
                    this.toggleOpenClose('workflows');
                }
            });
        }
    }
    ngAfterViewInit() {
        this.headerHeight = document.querySelector('.header')?.clientHeight ?? 48;
    }
    toggleOpenClose(type) {
        this.type = type;
        this.isMenuOpened = !this.isMenuOpened;
        if (this.isMenuOpened) {
            // Enable change detection because the menu is being toggled open
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
        }
        else {
            this.changeDetector.detectChanges();
            // We don't need to run change detection in any of the sidemenu components
            // while the menu is closed
            this.changeDetector.detach();
            this.clearGuidedWorkflowsSubcategoryCookie();
        }
    }
    closeMenu() {
        this.isMenuOpened = false;
        this.changeDetector.detectChanges();
        this.changeDetector.detach();
        this.clearGuidedWorkflowsSubcategoryCookie();
    }
    clearSteps() {
        this.workflowsMenuComponent.clearSteps();
    }
    getPathName(pathname) {
        return pathname
            .replace(/\/\d+\//, '/0/')
            .replace(/^\//, '')
            .replace(/\/$/, '');
    }
    clearGuidedWorkflowsSubcategoryCookie() {
        this.cookieService.delete(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME, '/');
    }
}
SideMenuComponent.ɵfac = function SideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.CookieService), i0.ɵɵdirectiveInject(i4.GuidedWorkflowsService)); };
SideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideMenuComponent, selectors: [["ycn-side-menu"]], viewQuery: function SideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(GuidedWorkflowsMenuComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workflowsMenuComponent = _t.first);
    } }, hostBindings: function SideMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function SideMenuComponent_scroll_HostBindingHandler($event) { return ctx.onScrollEvent($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl", showQuickflows: "showQuickflows", pagePath: "pagePath" }, standalone: false, decls: 14, vars: 14, consts: [[1, "side-menu", "right-0", "rotate-90"], [1, "side-menu-item"], [1, "side-panel", 3, "ngClass"], [1, "side-panel-header"], [1, "side-panel-title"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler", 3, "click"], ["ycnIcon", "", "name", "icon-open-arrow", 1, "icon-open-arrow"], [1, "side-panel-content", 3, "displaySecurityId", "securityId", "securityName", "securityUrl"], [1, "side-panel-content", 3, "pagePath", "categories", "selectedSubcategoryId"], [1, "side-panel-footer"], ["ycnTooltip", "", "tooltipTitle", "Open Quickflows", "tooltipPlacement", "left", 1, "btn", "btn-primary", "quickflows-toggler", 3, "click", "hidden"], [1, "d-flex", "mr-1"], ["ycnIcon", "", "name", "icon-quickflows", 1, "icon-quickflows", "rotate-270"], [1, "mr-1"], ["ycnTooltip", "", "tooltipTitle", "Open Workflows", "tooltipPlacement", "left", 1, "btn", "btn-outline", "btn-ghost", 3, "click", "hidden"], ["ycnIcon", "", "name", "icon-workflows", 1, "icon-workflows", "rotate-270"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline", 3, "click"], ["ycnTooltip", "", "tooltipTitle", "Quickflow Preferences", 1, "d-flex", "align-items-center", 3, "href"], ["ycnIcon", "", "name", "icon-gear", 1, "icon-gear", "text-gray-50", "fill-current"], [1, "ml-1"]], template: function SideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SideMenuComponent_Conditional_1_Template, 6, 1, "div", 1)(2, SideMenuComponent_Conditional_2_Template, 6, 1, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "div")(6, "div", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SideMenuComponent_Conditional_8_Template, 2, 0, "a", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "button", 6);
        i0.ɵɵlistener("click", function SideMenuComponent_Template_button_click_9_listener() { return ctx.closeMenu(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, SideMenuComponent_Conditional_11_Template, 1, 4, "ycn-quickflows-menu", 8)(12, SideMenuComponent_Conditional_12_Template, 1, 3, "ycn-guided-workflows-menu", 9)(13, SideMenuComponent_Conditional_13_Template, 5, 1, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showQuickflows ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.categories.length > 0 && ctx.showWorkflows ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("top", ctx.sidePanelTop, "px")("height", ctx.sidePanelHeight);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx.isMenuOpened));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.type === "quickflows" ? "Quickflows" : "Workflows");
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.type === "workflows" && ctx.workflowsMenuComponent && ctx.workflowsMenuComponent.selectedSteps.length > 0 ? 8 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.type === "quickflows" ? 11 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.type === "workflows" ? 12 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.type === "quickflows" ? 13 : -1);
    } }, dependencies: [i5.NgClass, i6.QuickflowsMenuComponent, i7.GuidedWorkflowsMenuComponent, i8.IconDirective], encapsulation: 2 });
